import { useSearchParams } from "react-router-dom";
import ConfigAgentReviewTab from "./components/ConfigAgentReviewTab";
export default function AgentsAuditPage() {
  const [params] = useSearchParams();
  return <ConfigAgentReviewTab key={params.get("review_id") || "list"} initialReviewId={params.get("review_id") || undefined}/>;
}
